import React from "react";
import NoData from "../../../assets/NoData/NoData";
import moment from "moment";

export default function ProfPreparation({ data }) {
  return (
    <>
      <div className="table">
        {/* {data && data.staff.length ? ( */}
      
          <table className="tg-second">
            <tr>
              <th className="tg-yw4l" rowlSpan={2}>Виды работ
                <th className="tg-yw4l" colSpan={1}>№ п/п</th>
                <th className="tg-yw4l" colSpan={1}>Виды работ</th>
              </th>
              <th className="tg-yw4l" rowSpan={6}>Объем работы в часах
                <th className="tg-yw4l" rowSpan={2}>I семестр
                  <th className="tg-yw4l">по плану</th>
                  <th className="tg-yw4l">выполнено</th>
                </th>
                  <th className="tg-yw4l" rowSpan={2} >II семестр
                  <th className="tg-yw4l">по плану</th>
                <th className="tg-yw4l">выполнено</th>
                </th>
                <th className="tg-yw4l" rowSpan={2}>Учебный год
                  <th className="tg-yw4l">по плану</th>
                  <th className="tg-yw4l">выполнено</th>
              </th>
              </th>
            </tr>
          </table>
        {/* ) : (
          <NoData text="данные отсутствуют" />
        )} */}
      </div>
    { !data &&  <div className="div__buttons">
        {/* <div className="buttons__edit">Изменить</div> */}
       
      </div>}
    </>
  );
}
